"use client";
import React from "react";
import { WobbleCard } from "../UI/wobble-card";
import IMG_0160 from "../../images/IMG_0160.jpeg";
import IMG_0812 from "../../images/IMG_0812.jpeg";
import IMG_0811 from "../../images/IMG_0811.jpeg";
import { useMediaQuery } from "../../Constants/useMediaQuery";
export function WobbleCardDemo() {
  // const enableAnimation = useMediaQuery("(min-width: 550px)");
  return (
    <div className="max-w-7xl mx-auto w-full flex flex-col gap-10 px-2 ssmm:px-4 ssm:px-5  smm:px-8 md:px-12 cxl:px-4">
      <div className="ml-2 flex flex-col gap-4 ">
        <h1 className=" text-3xl xsxm:text-4xl cxl:text-5xl font-title font-bold">
          ჩვენი ნამუშევრები
        </h1>
        <p className="text-sm smm:text-md cxl:text-lg pl-1 font-ArialGeo leading-5 max-w-3xl font-semibold">
          გაეცანით ჩვენს დასრულებულ პროექტებს, სადაც ჩანს ხარისხი, დეტალების
          სიზუსტე და კრეატიული მიდგომა თითოეულ შეკვეთაზე.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 px-1 sfm:px-3 xl:px-8 cxl:px-4 ">
        <WobbleCard containerClassName="col-span-1  lg:col-span-2 min-h-[500px] cxl:min-h-[700px]">
          <div className="relative w-full h-full overflow-hidden rounded-2xl">
            <img
              src={IMG_0812}
              alt="image 1"
              className="absolute inset-0 w-full h-full object-cover scale-110"
            />
            {/* <div className="absolute inset-0 bg-black/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" /> */}
          </div>
        </WobbleCard>
        <WobbleCard containerClassName="col-span-1 min-h-[300px]">
          <div className="relative w-full h-full overflow-hidden rounded-2xl">
            <img
              src={IMG_0811}
              alt="image 2"
              className="absolute inset-0 w-full h-full object-cover scale-105"
            />
          </div>
        </WobbleCard>
        <WobbleCard containerClassName="col-span-1 lg:col-span-3 min-h-[500px] cxl:min-h-[600px]">
          <div className="relative w-full h-full overflow-hidden rounded-2xl">
            <img
              src={IMG_0160}
              alt="image 3"
              className="absolute inset-0 w-full h-full object-cover scale-110"
            />
          </div>
        </WobbleCard>
      </div>
    </div>
  );
}
